import { DeviceType } from './DeviceType';
import { DefaultLocaleNames } from './easyclaim.app.internationalization/Translations';

export const DEFAULT_LANG = 'en';

export interface AppParameters {
	caseId: string | null;
	caseLinkId: string | null;
	shortLinkId: string | null;
	lang: string;
	webBrowserLang: string;
	isPolicyCheck: boolean;
	deviceType?: DeviceType;
	userAgentValue?: string | null;
}

export const getAppParameters = (): AppParameters => {
	const match = window.location.href.match('policycheck');
	const isPolicyCheck = !!match && match.length > 0;
	const params = new URLSearchParams(window.location.search);
	const lang = determineLang(params);
	const userAgentValue = getUserAgentValue();
	const deviceType = determineDeviceType();

	const appParameters: AppParameters = {
		caseId: determineCaseId(),
		caseLinkId: determineCaseLinkId(),
		shortLinkId: determineShortLinkId(),
		lang: lang,
		webBrowserLang: navigator.language,
		isPolicyCheck: isPolicyCheck,
		deviceType: deviceType,
		userAgentValue: userAgentValue,
	};

	const title = isPolicyCheck ? 'PolicyCheck' : 'EasyClaim';

	document.title = title;

	return appParameters;
};

export const determineLang = (
	params: URLSearchParams,
	locationHref: string = window.location.href
): string => {
	const queryStringLang: string | null = params.get('lang');
	let hostNameLang: string | null = null;

	const matchResult = locationHref.match(String.raw`([a-zA-Z]{2})(\.|-test\.)([a-zA-Z-]*)\.app`);

	if (!!matchResult && (matchResult?.length || 0) > 1) {
		hostNameLang = matchResult[1];
	}

	return [queryStringLang, hostNameLang].map(normalizeLang).find(isSupportedLang) ?? DEFAULT_LANG;
};

const normalizeLang = (lang: string | null): string | null => lang?.trim().toLowerCase() || null;

const isSupportedLang = (lang: string | null): lang is string =>
	!!lang && DefaultLocaleNames.includes(lang);

const determineCaseId = (): string | null => {
	const params = new URLSearchParams(window.location.search);
	let caseId: string | null = params.get('caseId');

	if (caseId == null) {
		const pathname = document.location.pathname;

		if (pathname.startsWith('/id/')) {
			// becouse pathname starts with '/id/' and contains 36 char (with 4 '-' signs) guid string
			caseId = pathname.substr(4, 36);
		}
	}

	return caseId;
};

const determineCaseLinkId = (): string | null => {
	let caseLinkId: string | null = null;

	const pathname = document.location.pathname;

	if (pathname.startsWith('/Link/')) {
		// becouse pathname starts with '/' sign and contains 36 char (with 4 '-' signs) guid string
		caseLinkId = pathname.substr(6, 36);
	}

	return caseLinkId;
};

const determineShortLinkId = (): string | null => {
	let shortLinkId: string | null = null;

	const pathname = document.location.pathname;

	if (pathname.length === 7) {
		// becouse pathname starts with '/' sign and contains 6 char
		shortLinkId = pathname.substr(1, 6);
	}

	return shortLinkId;
};

export function determineDeviceType(): DeviceType {
	const result: DeviceType = (function (a, b) {
		if (/(tablet|ipad|playbook|silk)|(android(?!.*mobi))/i.test(a)) {
			return DeviceType.tablet;
		} else if (
			/Mobile|Android|iP(hone|od)|IEMobile|BlackBerry|Kindle|Silk-Accelerated|(hpw|web)OS|Opera M(obi|ini)/.test(
				a
			)
		) {
			return DeviceType.mobile;
		}

		return DeviceType.desktop;
	})(getUserAgentValue(), 'http://detectmobilebrowser.com/mobile');

	return result;
}
function getUserAgentValue(): string {
	return navigator.userAgent || navigator.vendor || (window as any).opera || '';
}
